import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./linkWithIcon.html";
class LinkWithIcon extends LightningElement {
  constructor(...args) {
    super(...args);
    this.icon = 'new_window';
    this.caption = '';
    this.url = '';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LinkWithIcon, {
  publicProps: {
    icon: {
      config: 0
    },
    caption: {
      config: 0
    },
    url: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(LinkWithIcon, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;